export default "__VITE_ASSET__DjovxWdA__"